<div class="footer">
  <footer class="footer--persistent">
    <ul class='footer--persistent__links-ul'>
      <li *ngFor="let link of links" class="footer--persistent__link-li">
        <a [href]="link.route" target="_blank" class="footer--persistent__link">
          {{ link.label | l10n }}
        </a>
      </li>
    </ul>
    <div class="footer--persistent__copyright">
      <span>{{'copyright' | l10n }} &copy; {{ year | date:"yyyy" }} {{ brand | titlecase }}. </span>
      <span>{{ 'allRightsReserved' | l10n }}</span>
    </div>
  </footer>
</div>
